import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  AddressInfoDto,
  BaseBackResponse,
  SparePartCondition,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}requestsNew`;

export interface SparePartRequestLineNewModelDto {
  id: string;
  quantity: number;
  excludingTaxPurchasePriceEur: number;
  sparePartId?: string;
  externalOrderId?: string;
  externalRequestLineId?: string;
  sparePartSupplierId: string;
  minDeliveryDays?: number;
  maxDeliveryDays?: number;
  stockName?: string;
  condition: SparePartCondition;
  underWarranty?: boolean;
}

export interface CartLineReferencingRequestDto {
  id: string;
  subCategory?: string;
  quantity: number;
  manufacturerId?: string;
  manufacturerReference?: string;
  manufacturerName?: string;
  sparePartSupplierId?: string;
  sparePartSupplierReference?: string;
  sparePartSupplierName?: string;

  additionalInformation?: string;
  label?: string;
  additionalFiles?: string[];
}

interface CreateSparePartRequestNewModelCommandPayload {
  fileId?: string;
  sellerId: string;
  requestLines: SparePartRequestLineNewModelDto[];
  sparePartsToReference: CartLineReferencingRequestDto[];
  deliveryLocationType: string;
  address?: AddressInfoDto;
  deliveryLocationActorId?: string;
  alreadyOrdered?: boolean;
  externalOrderReference?: string;
}

export async function createSparePartRequestNewModelCommand(
  payload: CreateSparePartRequestNewModelCommandPayload,
): Promise<BaseBackResponse> {
  try {
    return await apiCall(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
